import { McCmColor, McDbText, McGePoint3d, MxCpp } from "mxcad";
import store from "@/store";
class rlTextData {
  constructor() {
    this.classTypeName = "rlText";
    this.m_groupName = "rlTextGroup";
    this.position = null;
    this.McDbText = new McDbText();
    this.mcDbId = null;
    this.Text = "";
    this.lineObjId = null;
    this.fontSize = store.state.platBtns.fontSize;
    this.dAngle = 0;
    this.textType = ""; //文字类型：截面尺寸，轴线号，轴线尺寸
    this.belongObjId = null; //文字所属的构件对象id
    this.color = null; //文字颜色
  }

  // 移动
  transformBy(_mat) {
    this.position.add(_mat);
    this.setNeedUpdateDisplay(true);
  }

  // 绘制
  draw(visible) {
    // if (this.Text && this.Text != "") {
    this.McDbText.textString = this.Text;
    if (this.textType == "测试网格") {
      this.McDbText.height = 80;
      //蓝色
      this.McDbText.trueColor = new McCmColor(0, 0, 255);
    } else if (this.textType == "测试节点") {
      this.McDbText.height = 80;
      //绿色
      this.McDbText.trueColor = new McCmColor(0, 255, 0);
    } else if (this.textType == "测试轴线") {
      this.McDbText.height = 120;
      //黄色
      this.McDbText.trueColor = new McCmColor(255, 255, 0);
    } else if (this.textType == "用途文字" || this.textType == "配筋数据文字") {
      if (this.textType == "用途文字") {
        this.McDbText.height = this.fontSize - 100;
        //白色
        this.McDbText.trueColor = new McCmColor(255, 255, 255);
      } else if (this.textType == "配筋数据文字") {
        this.McDbText.height = this.fontSize;
        //红色
        this.McDbText.trueColor = new McCmColor(255, 0, 0);
      }
      this.setChineseFont(); //设置中文字体
    } else if (this.textType.includes("构件号")) {
      this.classTypeName = "rlModelNo";
      // this.McDbText.height = this.fontSize-100;
      this.McDbText.height = this.fontSize;
      this.setChineseFont(); //设置中文字体
    } else if (this.textType == "楼板构件号") {
      //绿色
      this.McDbText.trueColor = new McCmColor(0, 255, 0);
      this.setChineseFont(); //设置中文字体
    } else if (this.textType == "测试轴线") {
      this.McDbText.height = 120;
      //黄色
      this.McDbText.trueColor = new McCmColor(255, 255, 0);
    } else if (this.textType == "用途文字" || this.textType == "配筋数据文字") {
      if (this.textType == "用途文字") {
        this.McDbText.height = this.fontSize - 100;
        //白色
        this.McDbText.trueColor = new McCmColor(255, 255, 255);
      } else if (this.textType == "配筋数据文字") {
        this.McDbText.height = this.fontSize;
        //红色
        this.McDbText.trueColor = new McCmColor(255, 0, 0);
      }
      this.setChineseFont(); //设置中文字体
    } else if (this.textType.includes("构件号")) {
      this.classTypeName = "rlModelNo";
      this.McDbText.height = this.fontSize - 100;
      if (this.textType == "楼板构件号") {
        //绿色
        this.McDbText.trueColor = new McCmColor(0, 255, 0);
      } else {
        //红色
        this.McDbText.trueColor = new McCmColor(255, 0, 0);
      }
    } else if (this.textType.includes("草图网格长度")) {
      this.McDbText.height = 200;
      //黑色
      const moduleBgs = localStorage.getItem("uSettings");
      const parsedData = moduleBgs ? JSON.parse(moduleBgs) : {};
      this.McDbText.trueColor = new McCmColor(0, 0, 0);
      if (parsedData && parsedData.bgc) {
        if (parsedData.bgc.value == 51)
          this.McDbText.trueColor = new McCmColor(255, 255, 255);
      }
    } else if (this.textType == "导出图纸") {
      this.McDbText.height = this.fontSize + 1500;
      //红色
      this.McDbText.trueColor = new McCmColor(255, 0, 0);
    } else {
      //红色
      // this.McDbText.trueColor = new McCmColor(255, 0, 0);
      this.McDbText.height = this.fontSize;
    }

    if (this.color) {
      this.McDbText.trueColor = this.color;
    }

    this.McDbText.verticalMode = 0;
    this.McDbText.position = this.McDbText.alignmentPoint = new McGePoint3d(
      this.position.x,
      this.position.y
    );
    this.McDbText.rotation = this.dAngle;
    this.McDbText.horizontalMode = 4;
    this.McDbText.visible = visible;
    this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.McDbText);
    store.commit("rlEntData/addEntityData", this);
    // }
  }

  //设置中文字体
  setChineseFont() {
    const mxcad = MxCpp.App.getCurrentMxCAD(); // 获取当前的 MxCAD 实例
    // 添加一个新的 TrueType 字体样式
    mxcad.AddTureTypeTextStyle("SimSunStyle", "SimSun");
    // 设置当前绘制的文字样式为新添加的样式
    mxcad.drawTextStyle = "SimSunStyle";
  }

  // 字体大小自适应
  calculateFontSize(Text) {
    let count = 0;
    for (let i = 0; i < Text.length; i++) {
      if (Text.charCodeAt(i) > 127 || Text.charCodeAt(i) == 94) {
        count += 2;
      } else {
        count++;
      }
    }

    // 标准400大小
    if (count > 3) {
      return 400 / (count / 3);
    } else {
      return 400;
    }
  }

  //删除
  erase() {
    this.mcDbId?.getMcDbEntity().erase();
  }
}

export { rlTextData };
